import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock } from '../../../../common/index';
import { Spinner } from '../../../../common/index';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/index';
import { Modal } from 'antd';
import {
  useGetErasmusChallengesQuery,
  useGetErasmusChallengeQuery,
  useDeleteErasmusChallengeMutation,
} from '../../../../../redux/services/erasmusChallenges';
import { useGetErasmusConsortiumsQuery } from '../../../../../redux/services/erasmusConsortium';
import { useGetErasmusUniversitiesQuery } from '../../../../../redux/services/erasmusUniversities';
import { useGetStudyProgramsQuery } from '../../../../../redux/services/study_programs';
import { useGetErasmusMobilityTypesQuery } from '../../../../../redux/services/erasmusMobilityTypes';
import { useGetErasmusMobilitySubtypesQuery } from '../../../../../redux/services/erasmusMobilitySubtypes';
import ErasmusChallengesTable from './ErasmusChallengesTable';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import ErasmusChallengesForm from './ErasmusChallengesEdit/ErasmusChallengesForm/ErasmusChallengesForm';
import dayjs from 'dayjs';

const ErasmusChallengesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: toastDeleteSuccess } = useToastMessages();

  const { data: erasmusChallenges, isLoading, refetch } = useGetErasmusChallengesQuery();
  const { data: consortiums } = useGetErasmusConsortiumsQuery();
  const { data: universities } = useGetErasmusUniversitiesQuery();
  const { data: studyPrograms } = useGetStudyProgramsQuery();
  const { data: erasmusMobilityTypes } = useGetErasmusMobilityTypesQuery();
  const { data: erasmusMobilitySubtypes } = useGetErasmusMobilitySubtypesQuery();
  const [
    deleteErasmusChallenge,
    { isSuccess: isDeleteSuccess },
  ] = useDeleteErasmusChallengeMutation();

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewId, setPreviewId] = useState(null);
  const { data: previewDetail, isLoading: isPreviewLoading } = useGetErasmusChallengeQuery(
    previewId,
    { skip: !previewId },
  );

  useEffect(() => {
    if (isDeleteSuccess) {
      toastDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  // Ensure erasmusChallenges is always an array
  const challengesArray = Array.isArray(erasmusChallenges) ? erasmusChallenges : [];

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Výzvy')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Nová výzva')}
        createUrl={routes.cmsErasmusChallengesCreate}
        permissionsBasic={'erasmus-challenges'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <ErasmusChallengesTable
            erasmusChallenges={challengesArray}
            onDelete={record => deleteErasmusChallenge(record.id)}
            onDetailClick={record => {
              navigate(`${routes.cmsErasmusChallengesEdit}/${record.id}`);
            }}
            onPreviewClick={(record) => {
              setPreviewId(record?.id);
              setPreviewOpen(true);
            }}
          />
        </CollapseBlock>
      </div>

      <Modal
        open={previewOpen}
        title={t('Náhľad výzvy')}
        onCancel={() => setPreviewOpen(false)}
        footer={null}
        width={980}
      >
        {isPreviewLoading ||
        !previewDetail ||
        !consortiums ||
        !universities ||
        !studyPrograms ||
        !erasmusMobilityTypes ||
        !erasmusMobilitySubtypes ? (
          <Spinner />
        ) : (
          <ErasmusChallengesForm
            initials={{
              ...previewDetail.challenge,
              deadline: previewDetail.challenge?.deadline
                ? dayjs(previewDetail.challenge.deadline)
                : undefined,
            }}
            isPreview={true}
            isEdit={false}
            consortiums={consortiums}
            universities={universities}
            studyPrograms={studyPrograms}
            erasmusMobilityTypes={erasmusMobilityTypes}
            erasmusMobilitySubtypes={erasmusMobilitySubtypes}
            onSubmit={() => {}}
          />
        )}
      </Modal>
    </>
  );
};

export default ErasmusChallengesPage;
